import React, { createContext, useState } from 'react';

const DesktopViewContext = createContext();

export const DesktopViewProvider = ({ children }) => {
  const [desktopView, setDesktopView] = useState(window.innerWidth > 1400);

  return (
    <DesktopViewContext.Provider value={{ desktopView, setDesktopView }}>
      {children}
    </DesktopViewContext.Provider>
  );
};

export default DesktopViewContext;
